import type { CreateDisputeResponse, UpdateDisputeResponse } from '@/types/api/disputes';

/**
 * Demo-mode fabricated response for creating a dispute.
 * Used as the demoFn for useCreateDispute.
 */
export async function createDisputeDemoResponse(): Promise<CreateDisputeResponse> {
  return {
    id: Date.now(),
    disputeNumber: `DSP-${String(Date.now()).slice(-3)}`,
  };
}

/**
 * Factory for the demo-mode update-dispute response, capturing the disputeId
 * closure. Returns the demoFn for useUpdateDispute.
 */
export function makeUpdateDisputeDemoFn(disputeId: number) {
  return async (): Promise<UpdateDisputeResponse> => {
    return {
      id: disputeId,
      disputeNumber: `DSP-${String(disputeId).padStart(3, '0')}`,
      message: 'Dispute updated successfully',
    };
  };
}
